import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from '../Util.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { commonIndexOf2u7nnfp9zp5hz as commonIndexOf } from './Buffer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function commonIndexOf_0(_this__u8e3s4, bytes, bytesOffset, byteCount, fromIndex, toIndex) {
  bytesOffset = bytesOffset === VOID ? 0 : bytesOffset;
  byteCount = byteCount === VOID ? bytes.q2() : byteCount;
  toIndex = toIndex === VOID ? 9223372036854775807n : toIndex;
  checkOffsetAndCount(fromInt(bytes.q2()), fromInt(bytesOffset), fromInt(byteCount));
  var fromIndex_0 = fromIndex;
  // Inline function 'kotlin.check' call
  if (!!_this__u8e3s4.c3u_1) {
    var message = 'closed';
    throw IllegalStateException().o(toString(message));
  }
  while (true) {
    var result = commonIndexOf(_this__u8e3s4.d3u_1, bytes, fromIndex_0, toIndex, bytesOffset, byteCount);
    if (!(result === -1n))
      return result;
    var lastBufferSize = _this__u8e3s4.d3u_1.k3s_1;
    // Inline function 'kotlin.Long.minus' call
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(lastBufferSize, fromInt(byteCount));
    var nextFromIndex = add(this_0, fromInt(1));
    if (nextFromIndex >= toIndex)
      return -1n;
    if (!isMatchPossibleByExpandingBuffer(_this__u8e3s4.d3u_1, bytes, bytesOffset, byteCount, fromIndex_0, toIndex)) {
      return -1n;
    }
    if (_this__u8e3s4.b3u_1.e3u(_this__u8e3s4.d3u_1, 8192n) === -1n)
      return -1n;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = fromIndex_0;
    fromIndex_0 = a >= nextFromIndex ? a : nextFromIndex;
  }
}
function isMatchPossibleByExpandingBuffer(_this__u8e3s4, bytes, bytesOffset, byteCount, fromIndex, toIndex) {
  if (_this__u8e3s4.k3s_1 < toIndex)
    return true;
  // Inline function 'kotlin.Long.plus' call
  var this_0 = subtract(_this__u8e3s4.k3s_1, toIndex);
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = add(this_0, fromInt(1));
  var tmp$ret$1 = 1n >= b ? 1n : b;
  var begin = convertToInt(tmp$ret$1);
  // Inline function 'kotlin.Long.plus' call
  var this_1 = subtract(_this__u8e3s4.k3s_1, fromIndex);
  // Inline function 'okio.minOf' call
  var b_0 = add(this_1, fromInt(1));
  // Inline function 'kotlin.comparisons.minOf' call
  var a = fromInt(byteCount);
  var tmp$ret$3 = a <= b_0 ? a : b_0;
  var limit = convertToInt(tmp$ret$3);
  var inductionVariable = limit - 1 | 0;
  if (begin <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var tmp0 = _this__u8e3s4.k3s_1;
      // Inline function 'kotlin.Long.minus' call
      var other = i;
      var tmp$ret$5 = subtract(tmp0, fromInt(other));
      if (_this__u8e3s4.f3u(tmp$ret$5, bytes, bytesOffset, i)) {
        return true;
      }
    }
     while (!(i === begin));
  return false;
}
//region block: exports
export {
  commonIndexOf_0 as commonIndexOf19ap7p38o0ad6,
};
//endregion

//# sourceMappingURL=RealBufferedSource.mjs.map
